define("SDB.GetSOVehicleIDs.SS2Model", ["SCModel", "Utils"], function (
  SCModelComponent,
  Utils
) {
  "use strict";

  var SCModel = SCModelComponent.SCModel;

  var SDBGetSOVehicleIDsSS2Model = function SDBGetSOVehicleIDsSS2Model() {
    SCModel.call(this);

    this.urlRoot = function () {
      return Utils.getAbsoluteUrl(
        getExtensionAssetsPath(
          "Modules/SDBSelectYourVehicle/SuiteScript2/SDB.GetSOVehicleIDs.Service.ss"
        ),
        true
      );
    };
  };

  SDBGetSOVehicleIDsSS2Model.prototype = SCModel.prototype;
  SDBGetSOVehicleIDsSS2Model.prototype.constructor = SDBGetSOVehicleIDsSS2Model;

  SDBGetSOVehicleIDsSS2Model.getInstance = function (options) {
    var This = this;
    this.instance = this.instance || new This(options);
    return this.instance;
  };

  return SDBGetSOVehicleIDsSS2Model;
});
